module.exports = __webpack_public_path__ + "img/Rainer_Lienhart@2x.68acc0a0.png";